import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DrawingCheckListType } from "../../Types/ChecklistTypes/DrawingCheckListType";
import { getAllDrawingChecklist } from "../../Thunks/CheckListThunks";

interface DrawingChecklistSliceState {
  loader: boolean; // for refres pages and inital loadings
  drawingChecklistData: DrawingCheckListType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: DrawingChecklistSliceState = {
  loader: false,
  drawingChecklistData: [],
  errorDisplay: "",
};

// handle api responces
const drawingChecklistSlice = createSlice({
  name: "drawingChecklistSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllDrawingChecklist.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllDrawingChecklist.pending, (state) => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(
        getAllDrawingChecklist.fulfilled,
        (state, action: PayloadAction<DrawingCheckListType[]>) => {
          state.loader = false;
          state.drawingChecklistData = action.payload;
        }
      );
  },
});

export const {} = drawingChecklistSlice.actions;
export default drawingChecklistSlice.reducer;
